<template>
	<v-card class="mb-5 pa-4" >
		<v-card-title>Timezone</v-card-title>
		<v-card-text>
			<div v-if="userTimezone">
				<div v-if="!timezoneConfirmed || timezoneConfirmed == 'correct'">
					<p>My timezone is {{userTimezone}} and the current time is {{ now | moment('timezone', userTimezone, 'LLLL')}}</p>
					<v-alert outlined color="grey">
						<v-row>
							<v-checkbox
							class="mt-0 pt-0 ml-3"
							v-model="timezoneConfirmed"
							label="Correct"
							color="green darken-3"
							value="correct"
							hide-details
							></v-checkbox>

							<v-checkbox
							class="mt-0 pt-0 ml-3"
							v-model="timezoneConfirmed"
							label="Incorrect"
							color="red dark darken-3"
							value="incorrect"
							hide-details
							></v-checkbox>
						</v-row>
					</v-alert>

				</div>
				<div v-else>
					<div v-if="timezoneConfirmed == 'incorrect'">
						<v-combobox label="Select Timezone" :items="timezones" v-model="user.timezone"></v-combobox>
					</div>
				</div>
			</div>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn @click="save" color="green" dark>Save</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import Vue from "vue"
	import * as mwTz from "../../assets/timezoneFunctions.js"
	export default{
		name: "TimeZoneSelector", 
		data: () => {
			return {
				timezoneConfirmed: false,
				timezone: false,
				selectedTimezone: '',
			}
		},
		props: ["user"],
		computed: { 
			now(){
				return new Date();
			},
			browserTimezone(){
				return mwTz.browserTimezone();
			},
			userTimezone(){
				return mwTz.userTimezone(this.user);
			},
			timezones(){
				return Vue.moment.tz.names(); 
			},
		},
		methods: {

			save(){
				var self = this;
				self.$store.dispatch( "updateDoc", {
					doc: "users/" + self.user.id, 
					data: {
						timezone: self.user.timezone
					},
					action: "update"
				} ).then( () => {
					self.timezoneConfirmed = "correct"
				})
			}
		},
		watch: {
			
		},
	}
</script>